/* ============================================================
   Vitalcep, shared luxe interactions
   ============================================================ */
(function () {
  'use strict';
  /* Every modular section can request this shared asset. Schedule initialization
     once, after the complete page has been parsed, so later sections exist. */
  if (window.__vluxInteractionsLoaded) return;
  window.__vluxInteractionsLoaded = true;

  function shopifyEndpoint(path) {
    var root = '/';
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      root = window.Shopify.routes.root;
    }
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root + String(path || '').replace(/^\/+/, '');
  }

  function updateCartBubble(count) {
    if (typeof count !== 'number') return;
    var accessibleLabel = count === 1 ? '1 item' : count + ' items';
    var bubbles = document.querySelectorAll(
      '.m-cart-count-bubble, .cart-count-bubble, [data-cart-count], .cart-count, #CartCount, .site-header__cart-count, .header__cart-count'
    );
    if (!bubbles.length && count > 0) {
      document.querySelectorAll('#cart-icon-bubble, a[href*="/cart"]').forEach(function (link) {
        if (link.querySelector('.m-cart-count-bubble, .cart-count-bubble')) return;
        var bubble = document.createElement('div');
        bubble.className = 'cart-count-bubble';
        bubble.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
        link.appendChild(bubble);
      });
      bubbles = document.querySelectorAll(
        '.m-cart-count-bubble, .cart-count-bubble, [data-cart-count], .cart-count, #CartCount, .site-header__cart-count, .header__cart-count'
      );
    }
    bubbles.forEach(function (el) {
      if (el.matches('[data-cart-count]')) {
        el.setAttribute('data-cart-count', String(count));
      }
      var target = el.querySelector('span[aria-hidden="true"], span:not(.visually-hidden)') || el;
      target.textContent = String(count);
      var hidden = el.querySelector('.visually-hidden');
      if (hidden) {
        hidden.textContent = accessibleLabel;
        hidden.style.position = 'absolute';
        hidden.style.width = '1px';
        hidden.style.height = '1px';
        hidden.style.padding = '0';
        hidden.style.margin = '-1px';
        hidden.style.overflow = 'hidden';
        hidden.style.clip = 'rect(0, 0, 0, 0)';
        hidden.style.whiteSpace = 'nowrap';
        hidden.style.border = '0';
      }
      var cartLink = el.closest('a[href*="/cart"], button');
      if (cartLink) cartLink.setAttribute('aria-label', 'Cart, ' + accessibleLabel);
      el.classList.remove('hidden', 'is-empty');
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  function cartSectionIds() {
    var ids = [];
    function add(id, selector) {
      if (ids.indexOf(id) !== -1) return;
      if (!selector || document.querySelector(selector)) ids.push(id);
    }
    add('cart-drawer', 'cart-drawer, #CartDrawer, .cart-drawer');
    add('cart-icon-bubble', '#cart-icon-bubble, #shopify-section-cart-icon-bubble, .cart-count-bubble, a[href*="/cart"]');
    add('cart-notification-product', 'cart-notification, #cart-notification, .cart-notification');
    add('cart-notification-button', 'cart-notification, #cart-notification, .cart-notification');
    add('cart-live-region-text', 'cart-notification, #cart-notification, .cart-notification');
    if (!ids.length) ids.push('cart-icon-bubble');
    return ids.slice(0, 5);
  }

  function replaceFromHtml(html, selectors, keepWrapper) {
    if (!html) return false;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    for (var i = 0; i < selectors.length; i++) {
      var selector = selectors[i];
      var target = document.querySelector(selector);
      var source = doc.querySelector(selector);
      if (!target || !source) continue;
      if (keepWrapper) {
        target.innerHTML = source.innerHTML;
      } else {
        target.replaceWith(source);
      }
      return true;
    }
    return false;
  }

  function renderCartSections(sections) {
    if (!sections) return false;
    var rendered = false;
    Object.keys(sections).forEach(function (id) {
      var html = sections[id];
      if (!html) return;
      var wrapper = '#shopify-section-' + id;
      if (replaceFromHtml(html, [wrapper], true)) {
        rendered = true;
        return;
      }
      if (id === 'cart-drawer') {
        rendered = replaceFromHtml(html, ['cart-drawer', '#CartDrawer', '.cart-drawer'], false) || rendered;
      } else if (id === 'cart-icon-bubble') {
        rendered = replaceFromHtml(html, ['#cart-icon-bubble', '.cart-count-bubble'], false) || rendered;
      } else if (id.indexOf('cart-notification') === 0 || id === 'cart-live-region-text') {
        rendered = replaceFromHtml(html, ['cart-notification', '#cart-notification', '.cart-notification'], false) || rendered;
      }
    });
    return rendered;
  }

  function renderThemeCart(addResponse) {
    var themeCart = document.querySelector('cart-drawer, cart-notification');
    try {
      if (themeCart && typeof themeCart.renderContents === 'function') {
        themeCart.renderContents(addResponse);
        return true;
      }
    } catch (err) {
      renderCartSections(addResponse && addResponse.sections);
    }
    return renderCartSections(addResponse && addResponse.sections);
  }

  function openThemeCart() {
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open();
      return true;
    }
    var cartNotification = document.querySelector('cart-notification');
    if (cartNotification && typeof cartNotification.open === 'function') {
      cartNotification.open();
      return true;
    }
    if (window.theme && window.theme.cart && typeof window.theme.cart.open === 'function') {
      window.theme.cart.open();
      return true;
    }
    var drawerTrigger = document.querySelector(
      '[aria-controls="CartDrawer"], [aria-controls="cart-drawer"], [data-cart-drawer-toggle], [data-drawer-open="cart"], .js-drawer-open-cart'
    );
    if (drawerTrigger) {
      drawerTrigger.click();
      return true;
    }
    return false;
  }

  function flashCartButton(btn, label, successText) {
    btn.classList.add('added');
    btn.textContent = successText || 'Added';
    setTimeout(function () {
      btn.classList.remove('added');
      btn.innerHTML = label;
      btn.disabled = false;
    }, 1600);
  }

  function emitCartEvents(cart, item) {
    var detail = { cart: cart, item: item };
    document.dispatchEvent(new CustomEvent('vlux:cart:updated', { detail: detail }));
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: detail }));
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: detail }));
    window.dispatchEvent(new CustomEvent('cart:refresh', { detail: detail }));
  }

  function bindAjaxCartForms(root) {
    var scope = root || document;
    var forms = Array.prototype.slice.call(scope.querySelectorAll('.vlux form[action*="/cart/add"]'));
    if (scope.matches && scope.matches('.vlux form[action*="/cart/add"]')) forms.unshift(scope);
    forms.forEach(function (form) {
      if (form.dataset.vluxAjaxCartBound === 'true') return;
      form.dataset.vluxAjaxCartBound = 'true';
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[type="submit"], [name="add"]');
        if (!btn || btn.disabled) return;
        var label = btn.innerHTML;
        btn.disabled = true;
        btn.textContent = 'Adding...';

        var formData = new FormData(form);
        if (!formData.has('quantity')) formData.append('quantity', '1');
        var sections = cartSectionIds();
        if (sections.length) {
          formData.append('sections', sections.join(','));
          formData.append('sections_url', window.location.pathname);
        }

        fetch(shopifyEndpoint('cart/add.js'), {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: formData
        })
          .then(function (res) {
            if (!res.ok) return res.json().then(function (err) { throw err; });
            return res.json();
          })
          .then(function (item) {
            renderThemeCart(item);
            return fetch(shopifyEndpoint('cart.js'), {
              headers: {
                'Accept': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              }
            }).then(function (res) {
              if (!res.ok) throw new Error('Could not refresh cart');
              return res.json();
            }).then(function (cart) {
              updateCartBubble(cart.item_count);
              flashCartButton(btn, label, 'Added');
              openThemeCart();
              emitCartEvents(cart, item);
            });
          })
          .catch(function (err) {
            var message = err && err.description ? err.description : 'Try again';
            btn.textContent = message;
            setTimeout(function () {
              btn.innerHTML = label;
              btn.disabled = false;
            }, 2200);
          });
      });
    });
  }

  function initVluxInteractions() {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Mobile nav */
  var menuBtn = document.getElementById('menu-btn');
  var closeBtn = document.getElementById('close-menu');
  var mobileNav = document.getElementById('mobile-nav');
  if (menuBtn && mobileNav) {
    menuBtn.addEventListener('click', function () { mobileNav.classList.add('open'); document.body.style.overflow = 'hidden'; });
  }
  if (closeBtn && mobileNav) {
    closeBtn.addEventListener('click', function () { mobileNav.classList.remove('open'); document.body.style.overflow = ''; });
  }
  if (mobileNav) {
    mobileNav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { mobileNav.classList.remove('open'); document.body.style.overflow = ''; });
    });
  }

  /* Scroll reveal */
  if ('IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) e.target.classList.add('in'); });
    }, { threshold: 0.1 });
    document.querySelectorAll('.reveal, .reveal-left, .reveal-right').forEach(function (el) { obs.observe(el); });
  } else {
    document.querySelectorAll('.reveal, .reveal-left, .reveal-right').forEach(function (el) { el.classList.add('in'); });
  }

  /* Stat counters */
  if ('IntersectionObserver' in window) {
    var countObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var target = parseFloat(el.dataset.target);
        var isDecimal = el.dataset.decimal === 'true';
        var current = 0, step = target / 55;
        var timer = setInterval(function () {
          current = Math.min(current + step, target);
          el.textContent = isDecimal ? current.toFixed(1) : Math.round(current).toLocaleString();
          if (current >= target) clearInterval(timer);
        }, 18);
        countObs.unobserve(el);
      });
    }, { threshold: 0.5 });
    document.querySelectorAll('[data-target]').forEach(function (el) { countObs.observe(el); });
  }

  /* Nav shadow + parallax */
  var navEl = document.querySelector('.nav-glass');
  var parallaxEls = Array.prototype.slice.call(document.querySelectorAll('[data-parallax]'));
  var ticking = false;
  function onScroll() {
    var y = window.scrollY || window.pageYOffset;
    if (navEl) navEl.classList.toggle('scrolled', y > 24);
    if (!reduceMotion) {
      for (var i = 0; i < parallaxEls.length; i++) {
        var el = parallaxEls[i];
        var speed = parseFloat(el.dataset.parallax) || 0;
        el.style.transform = 'translate3d(0,' + (y * speed).toFixed(1) + 'px,0)';
      }
    }
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { window.requestAnimationFrame(onScroll); ticking = true; }
  }, { passive: true });
  onScroll();

  /* FAQ accordion */
  window.toggleFaq = function (item) {
    if (!item) return;
    var group = item.closest('[data-vlux-faq]') || item.parentElement || document;
    var isOpen = item.classList.contains('open');
    group.querySelectorAll('.faq-item').forEach(function (i) {
      i.classList.remove('open');
      var btn = i.querySelector('.faq-question');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
    if (!isOpen) {
      item.classList.add('open');
      var activeBtn = item.querySelector('.faq-question');
      if (activeBtn) activeBtn.setAttribute('aria-expanded', 'true');
    }
  };
  document.querySelectorAll('.faq-question').forEach(function (btn) {
    if (btn.dataset.vluxFaqBound === 'true') return;
    btn.dataset.vluxFaqBound = 'true';
    btn.addEventListener('click', function () { window.toggleFaq(btn.closest('.faq-item')); });
  });

  /* Tabs (generic: .tab-btn[data-tab] -> #id) */
  document.querySelectorAll('.tab-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = btn.dataset.tab;
      if (!target) return;
      var group = btn.closest('[data-tab-group]') || document;
      group.querySelectorAll('.tab-btn').forEach(function (b) { b.classList.remove('active'); });
      group.querySelectorAll('.tab-panel').forEach(function (p) { p.classList.remove('active'); });
      btn.classList.add('active');
      var panel = document.getElementById(target);
      if (panel) panel.classList.add('active');
    });
  });

  /* Testimonial carousels (supports multiple) */
  document.querySelectorAll('[data-carousel]').forEach(function (root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('.testi-slide'));
    var dotsWrap = root.querySelector('[data-dots]');
    if (!slides.length || !dotsWrap) return;
    var idx = 0, timer = null;
    slides.forEach(function (_, i) {
      var dot = document.createElement('button');
      dot.className = 'testi-dot' + (i === 0 ? ' active' : '');
      dot.setAttribute('role', 'tab');
      dot.setAttribute('aria-label', 'Show testimonial ' + (i + 1));
      dot.addEventListener('click', function () { go(i); restart(); });
      dotsWrap.appendChild(dot);
    });
    var dots = Array.prototype.slice.call(dotsWrap.children);
    function go(n) {
      slides[idx].classList.remove('active'); dots[idx].classList.remove('active');
      idx = (n + slides.length) % slides.length;
      slides[idx].classList.add('active'); dots[idx].classList.add('active');
    }
    function start() { if (!reduceMotion) timer = setInterval(function () { go(idx + 1); }, 5000); }
    function stop() { clearInterval(timer); }
    function restart() { stop(); start(); }
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    start();
  });

  /* AJAX add-to-cart for real Shopify product forms in VLUX sections. */
  bindAjaxCartForms(document);
  document.querySelectorAll('.vlux form[action*="/cart/add"]').forEach(function (form) {
    if (form.dataset.vluxAjaxCartBound === 'true') return;
    form.dataset.vluxAjaxCartBound = 'true';
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"], [name="add"]');
      if (!btn || btn.disabled) return;
      var label = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (err) { throw err; });
          return res.json();
        })
        .then(function () { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }); })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          updateCartBubble(cart.item_count);
          flashCartButton(btn, label, '✓ Added');
          openThemeCart();
          document.dispatchEvent(new CustomEvent('vlux:cart:updated', { detail: { cart: cart } }));
        })
        .catch(function (err) {
          var message = err && err.description ? err.description : 'Try again';
          btn.textContent = message;
          setTimeout(function () {
            btn.textContent = label;
            btn.disabled = false;
          }, 2200);
        });
    });
  });

  /* Add-to-Cart micro-feedback for PLACEHOLDER buttons only. */
  document.querySelectorAll('a.btn-primary, button.btn-primary').forEach(function (btn) {
    if (btn.textContent.trim().toLowerCase() !== 'add to cart') return;
    if (btn.type === 'submit' || btn.closest('form')) return;
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (btn.classList.contains('added')) return;
      var label = btn.textContent;
      btn.classList.add('added');
      btn.innerHTML = '✓ Added to Cart';
      setTimeout(function () { btn.classList.remove('added'); btn.textContent = label; }, 1600);
    });
  });

  /* Ingredient checklist toggle */
  document.querySelectorAll('.ingredient').forEach(function (li) {
    li.setAttribute('tabindex', '0');
    li.setAttribute('role', 'checkbox');
    li.setAttribute('aria-checked', 'false');
    function toggle() {
      var on = li.classList.toggle('checked');
      li.setAttribute('aria-checked', on ? 'true' : 'false');
      var tick = li.querySelector('.tick');
      if (tick) tick.innerHTML = on ? '✓' : '';
    }
    li.addEventListener('click', toggle);
    li.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); } });
  });

  /* Generic AJAX-less form feedback: data-feedback="Sending...|Message Sent" */
  document.querySelectorAll('form[data-feedback]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var parts = form.dataset.feedback.split('|');
      var pending = parts[0] || 'Sending…';
      var done = parts[1] || 'Sent';
      var btn = form.querySelector('[type="submit"]');
      var msg = form.querySelector('[data-feedback-msg]');
      if (!btn) return;
      var original = btn.textContent;
      btn.disabled = true; btn.textContent = pending;
      setTimeout(function () {
        btn.textContent = '✓ ' + done;
        if (msg) msg.textContent = form.dataset.feedbackNote || '';
        form.querySelectorAll('input, textarea').forEach(function (f) { f.value = ''; });
        var sel = form.querySelector('select'); if (sel) sel.selectedIndex = 0;
        setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 2000);
      }, 700);
    });
  });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVluxInteractions, { once: true });
  } else {
    initVluxInteractions();
  }
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('.reveal, .reveal-left, .reveal-right').forEach(function (el) {
      el.classList.add('in');
    });
    event.target.querySelectorAll('.faq-question').forEach(function (btn) {
      if (btn.dataset.vluxFaqBound === 'true') return;
      btn.dataset.vluxFaqBound = 'true';
      btn.addEventListener('click', function () { window.toggleFaq(btn.closest('.faq-item')); });
    });
    bindAjaxCartForms(event.target);
    event.target.querySelectorAll('.vlux form[action*="/cart/add"]').forEach(function (form) {
      if (form.dataset.vluxAjaxCartBound === 'true') return;
      form.dataset.vluxAjaxCartBound = 'true';
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[type="submit"], [name="add"]');
        if (!btn || btn.disabled) return;
        var label = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Adding...';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        })
          .then(function (res) {
            if (!res.ok) return res.json().then(function (err) { throw err; });
            return res.json();
          })
          .then(function () { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }); })
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            updateCartBubble(cart.item_count);
            flashCartButton(btn, label, '✓ Added');
            openThemeCart();
          })
          .catch(function (err) {
            var message = err && err.description ? err.description : 'Try again';
            btn.textContent = message;
            setTimeout(function () {
              btn.textContent = label;
              btn.disabled = false;
            }, 2200);
          });
      });
    });
  });
})();
